import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '@res/ng-repository';
import { FilterModel } from 'ag-grid-community';
import { IssueFirestoreService } from '../../services/issue.firestore.service';
import { IssueStateModel } from './issue.store';
import { IssueActions } from './issue.action';

@State<IssueStateModel>({
  name: 'Iissues',
  defaults: {
    Iissues: [],
    isSubscribed: false,
    isLoading: false,
    sort: [],
  },
})
@Injectable()
export class IssueState {
  private IissuesService = inject(IssueFirestoreService);
  // private issueState = inject(IssueState);
  // private dbIssue = inject(OrmService).issueCollection;
  // private authService = inject(Auth);
  // private store = inject(Store);

  @Action(IssueActions.GetAllIssues)
  async getAllIssues(ctx: StateContext<IssueStateModel>) {
    ctx.patchState({ isLoading: true });
    const Iissues = await this.IissuesService.GetAll();
    ctx.patchState({
      Iissues: Iissues.map(({ data, ref }) => ({ ...data, ref })),
      isLoading: false,
    });
  }

  @Action(IssueActions.UpdateIssue)
  async updateIssue(ctx: StateContext<IssueStateModel>, { IissueData, ref }: IssueActions.UpdateIssue) {
    await this.IissuesService.Update(ref, IissueData);
  }

  @Action(IssueActions.UpdateIssueResult)
  updateIssueResult(ctx: StateContext<IssueStateModel>, { data }: IssueActions.UpdateIssueResult) {
    patchState<IssueStateModel>(ctx, 'Iissues', data);
  }

  @Action(IssueActions.PaginateQueryIssue)
  async queryIssue(
    ctx: StateContext<IssueStateModel>,
    { request, isResetAfterFilterOrSort }: IssueActions.PaginateQueryIssue,
  ) {
    const state = ctx.getState();
    // if (request.filterModel && (request.filterModel as FilterModel)['issueId']) {
    //   (request.filterModel as FilterModel)['issueId']['values'] = (request.filterModel as FilterModel)[
    //     'issueId'
    //   ].values.map(
    //     (v: string) => this.store.selectSnapshot(IssueState.issues).find((issue) => issue.companyName === v)?.ref
    //   );
    // }
    // if (issueId) {
    //   request.filterModel = {
    //     issueId: { filter: this.dbIssue.ref(this.dbIssue.id(issueId)), type: 'equals' },
    //     ...request.filterModel,
    //   };
    // }

    ctx.patchState({ isLoading: true });
    const { runs, direction } = this.IissuesService.SetQuery({
      ...request,
      count: state.Iissues.length,
      data: state.Iissues,
    });
    if (isResetAfterFilterOrSort) {
      const trCound = state.Iissues.length;
      state.Iissues = [];
      state.Iissues.length = trCound;
    }
    if (JSON.stringify(state.filter) !== JSON.stringify(request.filterModel)) {
      ctx.patchState({ filter: request?.filterModel });

      state.Iissues = [];
      state.Iissues.length = await this.IissuesService.GetBuildedCount(runs);
    }
    if (state.Iissues.length !== 0) {
      runs.push(...this.IissuesService.SetLimit({ ...request, count: state.Iissues.length, data: [] }));
      ctx.patchState({ sort: request?.sortModel });

      if (!runs.some((x) => x.type === 'limit')) {
        throw new Error('No limit');
      }
      const Iissues = await this.IissuesService.GetBuildedData(runs);
      ctx.patchState({ filter: request?.filterModel });

      if (direction === 'asc') {
        Iissues.reverse().forEach(
          ({ data, ref }, i) =>
            (state.Iissues[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      } else {
        Iissues.forEach(
          ({ data, ref }, i) =>
            (state.Iissues[i + (request?.startRow ?? 0)] = {
              ...data,
              ref,
            }),
        );
      }
    }

    ctx.patchState({ isLoading: false, Iissues: state.Iissues });
  }

  @Action(IssueActions.IssueError)
  IissuesError(ctx: StateContext<IssueStateModel>, { error }: IssueActions.IssueError) {
    console.error({ error });
    // await this.IissuesService.Update(id, IissuesData);
  }

  @Action(IssueActions.DeleteIssues)
  async deletetIissues(ctx: StateContext<IssueStateModel>, { refs }: IssueActions.DeleteIssues) {
    await this.IissuesService.BatchDelete(refs);
  }

  @Action(IssueActions.GetSumsCountOf)
  public async getCountOf(
    ctx: StateContext<IssueStateModel>,
    { fields, timePeriod, filterModel }: IssueActions.GetSumsCountOf,
  ) {
    const query = {
      filterModel: {},
      startRow: undefined,
      endRow: undefined,
      sortModel: [],
      data: [],
      count: 0,
    };
    if (timePeriod.dateFrom && timePeriod.dateTo) {
      (query.filterModel as FilterModel)['createdAt'] = {
        colId: 'createdAt',
        type: 'inRange',
        filter: timePeriod.dateFrom,
        filterTo: timePeriod.dateTo,
      };
    }
    // if (issueId) {
    //   filterModel = { issueId: { filter: this.dbIssue.ref(this.dbIssue.id(issueId)), type: 'equals' }, ...filterModel };
    // }
    for (const [fieldKey, fieldFilter] of Object.entries(filterModel ?? {})) {
      (query.filterModel as FilterModel)[fieldKey] = fieldFilter;
    }
    (query.filterModel as FilterModel)['paymentResult'] = {
      colId: 'paymentResult',
      type: 'equals',
      filter: 'Successful',
    };

    // query.filterModel.paymentResult = { colId: 'paymentResult', type: 'equals', filter: 'Successful' };
    const extraQuerry = this.IissuesService.SetQuery(query);
    const querrys: { [key: string]: { sum: number; count: number } } = {};
    for (const field of fields) {
      querrys[field.sumId] = {
        sum: await this.IissuesService.QuerySumByCreationDate(field.sumId, extraQuerry.runs),
        count: await this.IissuesService.QueryCountByCreationDate(field.countId, field.countValue, extraQuerry.runs),
      };
    }
    ctx.patchState({ sums: querrys });
  }

  @Selector()
  static Iissues(state: IssueStateModel) {
    return state.Iissues;
  }
  @Selector()
  static IissuesCount(state: IssueStateModel) {
    return state.Iissues.length;
  }

  @Selector()
  static sums(state: IssueStateModel) {
    return state.sums;
  }

  @Selector()
  static sumsByParams(state: IssueStateModel) {
    return (field: string) => state?.sums?.[field];
  }

  @Selector()
  static IissuesState(state: IssueStateModel) {
    return state;
  }
}
